"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { isValidLocator, locatorToSteps, getSchemaByLocator, locatorToField, stepsToLocator, DataLocatorStepObjectProperty, getNameComponentsForLocator, getIconUriForLocator, getFullNameForLocator, getNameForLocator } from '@membranehq/sdk';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { toHeaderCase } from 'js-convert-case';
import { doesSchemaMatchValueType } from '../value-spec.mjs';
import { filterOptionsByLabel } from './utils.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, key + "" , value);
class ObjectFieldsOptionFactory {
  constructor(parameters) {
    __publicField(this, "parameters", parameters);
  }
  async getOptions({ input, spec }) {
    return this.getOptionsSync({ input, spec });
  }
  getOptionsSync({ input, spec }) {
    const locator = this.parameters.locator ?? "$";
    if (!isValidLocator(locator)) {
      return [];
    }
    const locatorSteps = locatorToSteps(locator);
    const objectSchema = getSchemaByLocator(this.parameters.schema, locator);
    if (objectSchema?.type !== "object") {
      return [];
    }
    const isSchemaEditable = this.parameters.editableSchemaLocators?.some(
      (l) => locatorToField(stepsToLocator(locatorSteps)).startsWith(locatorToField(l))
    );
    const showFullName = !!input;
    const options = [];
    if (doesSchemaMatchValueType(objectSchema, spec) && locator && locator !== "$") {
      options.push({
        label: "Whole Object",
        value: {
          $var: stepsToLocator(locatorToSteps(locator))
        },
        iconType: SvgIconType.SchemaType_object
      });
    }
    for (const [fieldKey, fieldSchema] of Object.entries(objectSchema.properties || {})) {
      const propertyLocator = [...locatorSteps, new DataLocatorStepObjectProperty(fieldKey)];
      const objectNameComponents = getNameComponentsForLocator(this.parameters.schema, locator);
      options.push(
        ...this.parameters.getOptionsForSchema({
          schema: this.parameters.schema,
          locator: propertyLocator,
          valueSpec: spec,
          showIcons: !this.parameters.isSection,
          schemaByLocator: fieldSchema,
          exampleVariables: this.parameters.exampleVariables,
          skipNameComponentsPrefix: objectNameComponents,
          nameComponentsByLocator: [
            /* FIXME: strictNullCheck temporary fix */
            // @ts-expect-error TS(2488): Type 'string[] | undefined' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
            ...objectNameComponents,
            fieldSchema?.title ?? toHeaderCase(fieldKey)
          ],
          expandObject: false
        })
      );
    }
    if (isSchemaEditable) {
      options.push({
        label: `New${this.parameters?.name ? ` "${this.parameters.name}"` : ""} property`,
        searchLabel: "",
        iconType: SvgIconType.Add,
        addVariable: `${stepsToLocator(locatorSteps)}`
      });
    }
    const filteredOptions = filterOptionsByLabel(options, input);
    if (filteredOptions.length > 0) {
      const result = filteredOptions;
      if (this.parameters.isSection) {
        result.unshift({
          label: showFullName ? getFullNameForLocator(this.parameters.schema, locator) : getNameForLocator(this.parameters.schema, locator),
          isSection: true,
          iconUri: getIconUriForLocator(this.parameters.schema, locator)
        });
      }
      return result;
    } else {
      return [];
    }
  }
}

export { ObjectFieldsOptionFactory };
